export const contactData = [
    {
      icon: "uil uil-fast-mail",
      title: "Email",
      data: "amamasoufian@gmail.com",
      link: "mailto:amamasoufian@gmail.com",
    },
    {
      icon: "uil uil-whatsapp",
      title: "Whatsapp",
      data: "+213676169200",
      link: "*",
    },
    {
      icon: "uil uil-telegram",
      title: "Telegram",
      data: "@Sifo_Amama",
      link: "https://t.me/Sifo_Amama",
    },
  ];